import BackgroundGrid from "@assets/illustrations/background-grid.svg?react";
import { MapListTwoToneIcon } from "@components/common/icons";
import { ProjectLocationEditor } from "@components/project-location-editor/project-location-editor";
import { BaseProjectProps } from "@custom-types/project-types";
import { Button, neutral, Text } from "@flat-ui";
import { Stack } from "@mui/material";

interface Props extends BaseProjectProps {
  /** Whether the project location editor dialog is open */
  isDialogOpen: boolean;

  /** Callback to open the project location editor dialog */
  openDialog: () => void;

  /** Callback to close the project location editor dialog */
  closeDialog: () => void;

  /** Whether the map allows interaction (e.g. adding/editing coordinates). Defaults to true. */
  isInteractive?: boolean;
}

/**
 * Component to display when a project does not have a location and
 * thus it cannot be displayed on the project map.
 */
export function ProjectMapEmptyPage({
  project,
  isDialogOpen,
  openDialog,
  closeDialog,
  isInteractive = true,
}: Props): JSX.Element {
  return (
    <Stack
      sx={{
        textAlign: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <BackgroundGrid />
        <MapListTwoToneIcon
          sx={{ height: "44px", width: "44px", position: "absolute" }}
        />
      </Stack>

      <Text
        variant="heading16"
        sx={{
          color: neutral[600],
          marginTop: "8px",
        }}
      >
        No coordinates set for this project
      </Text>

      <Button
        variant="ghost"
        onClick={openDialog}
        sx={{
          marginTop: "12px",
          visibility: isInteractive ? "visible" : "hidden",
        }}
      >
        Add coordinates
      </Button>

      {isInteractive && isDialogOpen && (
        <ProjectLocationEditor project={project} onClose={closeDialog} />
      )}
    </Stack>
  );
}
